module.exports = __webpack_public_path__ + "img/yasuo.79eecf27.png";